import { User as ProfileIcon } from "@phosphor-icons/react"

export default ProfileIcon
